import { memo, useCallback, useEffect, useState } from "react";
import { isEqual } from "lodash";

const Attribute = (props) => {
  const { styles, product, productData } = props;
  const [option, setOption] = useState([]);
  const { retailer_products: rp, variances } = productData;
  const noStockVariants = rp.stocks.filter((i) => !i.stock);
  const selectedAttr = variances.find(
    (item) => item._id === product.variance_id
  );

  const selectedOption = {};
  for (let i = 0; i < selectedAttr.attributes.length; i++) {
    const attr = selectedAttr.attributes[i];
    selectedOption[attr.name] = attr.val_name;
  }

  const onChange = (event) => {
    const { name, value } = event.target,
      available = {},
      attributes = [];
    const v = variances.filter((item) => {
      let va = item.attributes.find(
        (op) => op.name === name && op.val_name === value
      );

      return va ? true : false;
    });

    const variants = variances.filter(
      (i) => !noStockVariants.find((j) => j.variance_id === i._id)
    );

    const attrs = [];
    for (let i = 0; i < variants.length; i++) {
      const variance = variants[i];
      if (variance.is_available && !variance.is_base_variance) {
        attrs.push(...variance.attributes);
      }
    }

    for (let i = 0; i < v.length; i++) {
      const variance = v[i];
      const attributes = variance.attributes.filter(
        (item) => item.name !== name
      );

      for (let j = 0; j < attributes.length; j++) {
        const attribute = attributes[j];

        if (available[attribute.name]) {
          available[attribute.name][attribute.val_name] = variance.is_available;
        } else {
          available[attribute.name] = {
            [attribute.val_name]: variance.is_available,
          };
        }
      }
    }

    for (let attr of attrs) {
      if (available[attr.name] && available[attr.name][attr.val_name]) {
        if (attributes.find((v) => v.name === attr.name)) {
          const index = attributes.findIndex((v) => v.name === attr.name);
          if (index !== -1)
            if (attributes[index].values.indexOf(attr.val_name) === -1)
              attributes[index].values.push(attr.val_name);
        } else {
          attributes.push({
            name: attr.name,
            values: [attr.val_name],
          });
        }
      }
    }

    const attrMap = option.map((a) => {
      const op = attributes.find((att) => att.name === a.name);
      if (op) {
        return op;
      } else {
        return a;
      }
    });

    setOption(attrMap);

    const newSelected = { ...selectedOption, [name]: value };
    const selected = variances.find((v) => {
      let va = {};
      for (let i = 0; i < v.attributes.length; i++) {
        va[v.attributes[i].name] = v.attributes[i].val_name;
      }
      return isEqual(va, newSelected);
    });

    let varianceName = selected.attributes
      .map((v) => `${v.name} ${v.val_name}`)
      .join(" : ");

    props.onChange(selected._id, product._id, varianceName);
  };

  const availableOptions = useCallback(() => {
    const op = [];
    const { retailer_products: rp, variances } = productData;
    const noStockVariants = rp.stocks.filter((i) => !i.stock);
    const variants = variances.filter(
      (i) => !noStockVariants.find((j) => j.variance_id === i._id)
    );

    const sv = variances.find((item) => item._id === product.variance_id);

    const attrs = [];
    if (sv.attributes.length > 1) {
      for (let k = 0; k < sv.attributes.length; k++) {
        const vAttr = sv.attributes[k];
        const availableVariants = variants.filter((v) => {
          return v.attributes.find((a) => a.val_id === vAttr.val_id)
            ? true
            : false;
        });
        for (let i = 0; i < availableVariants.length; i++) {
          const variance = availableVariants[i];
          if (variance.is_available && !variance.is_base_variance) {
            attrs.push(...variance.attributes);
          }
        }
      }
    } else {
      for (let i = 0; i < variants.length; i++) {
        const variance = variants[i];
        if (variance.is_available && !variance.is_base_variance) {
          attrs.push(...variance.attributes);
        }
      }
    }

    for (let attr of attrs) {
      if (op.find((v) => v.name === attr.name)) {
        const index = op.findIndex((v) => v.name === attr.name);
        if (index !== -1)
          if (op[index].values.indexOf(attr.val_name) === -1)
            op[index].values.push(attr.val_name);
      } else {
        op.push({
          name: attr.name,
          values: [attr.val_name],
        });
      }
    }

    setOption(op);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productData]);

  useEffect(() => {
    availableOptions();
  }, [availableOptions]);
  return option.map((i, key) => (
    <div key={key} className={styles.bagsItemEdit}>
      <label>{i.name}</label>
      <select
        name={i.name}
        className="form-control"
        onChange={(e) => onChange(e)}
        value={selectedOption[i.name]}
      >
        {i.values.map((val) => (
          <option key={val} value={val}>
            {val}
          </option>
        ))}
      </select>
    </div>
  ));
};

export default memo(Attribute);
